// extracted by mini-css-extract-plugin
export default {"Section":"Escalones2_Section__ZTv+S","Article":"Escalones2_Article__RFXQO","ArticleH2":"Escalones2_ArticleH2__-NvoC","ArticleH3":"Escalones2_ArticleH3__gXpwp"};